import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSafetyFireExtinguisher = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "safety-fire-extinguisher" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,5.5V3.375H7.5V5.5A4.481,4.481,0,0,0,5.25,9.375v12a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-12A4.481,4.481,0,0,0,12,5.5Z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "a",
			points: "23.25 5.625 15.75 4.875 15.75 1.875 23.25 1.125 23.25 5.625"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,3.375h-9a6,6,0,0,0-6,6v10.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 3.375,
			x2: 5.25,
			y2: 1.125
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "14.25 10.875 9.75 10.875 9.75 18.375 14.25 18.375"
		})
	]
});
export default SvgSafetyFireExtinguisher;
